<template>
    <div>
        <l-card-headline class="tw-border-0 tw-border-b tw-border-solid tw-border-gray-100 tw-pb-4">
            {{ $t("profile.attachments.title") }}
        </l-card-headline>

        <div class="tw-pt-4">
            <div v-if="!attachments.length" class="tw-text-center tw-text-gray-400">
                <div class="tw-mt-4">
                    {{ $t("profile.attachments.empty") }}
                </div>
            </div>

            <l-file-attachments-list v-else :files="attachments" />
        </div>
    </div>
</template>

<script>
import LCardHeadline from "@/components/LCardHeadline";
import LFileAttachmentsList from "@/components/LUserProfile/LFileAttachmentsList";

export default {
    components: {
        LCardHeadline,
        LFileAttachmentsList,
    },
    props: {
        attachments: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
